import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

export const ModeratorMarkCard = ({ totalMark, maxMark }) => {
  return (
    <Card sx={{ mt: 2, mb: 2 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Moderator Mark
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            gap: 0.5,
          }}
        >
          <Typography variant="h3" component="span" color="primary">
            {totalMark}
          </Typography>
          <Typography variant="h3" component="span" color="text.secondary">
            / {maxMark}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Total mark calculated from Assessment Objective marks
        </Typography>
      </CardContent>
    </Card>
  );
};
